import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Phone, Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';

const MobileCTA = () => {
  const { language, t } = useLanguage();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background border-t border-border shadow-2xl">
      <div className="flex divide-x divide-border">
        <a href="tel:9363200763" className="flex-1">
          <Button 
            variant="ghost" 
            className="w-full h-14 rounded-none flex items-center justify-center space-x-2 text-primary"
          >
            <Phone className="h-5 w-5" />
            <span className="font-semibold">{t('hero.cta.call')}</span>
          </Button>
        </a>
        
        <Link to={`/${language}/quote`} className="flex-1">
          <Button 
            variant="hero" 
            className="w-full h-14 rounded-none flex items-center justify-center space-x-2"
          >
            <Calculator className="h-5 w-5" />
            <span className="font-semibold">{t('hero.cta.quote')}</span>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;